<p-dialog
	p-dialog
  appendTo="body"
	header="{{ 'UserGroupSubscriptionMaintenance.TenantMappingUserGrouupDetailDialog.Title' | translate }}"
	[style]="{width: '50vw'}"
	[(visible)]="isVisible"
	(onHide)="onHide(false)"
	[modal]="true"
  [draggable]="false"
	[resizable]="false"
  [dismissableMask]="true">
	<p-card>
		<laas-data-table
				#table
				appendTo="body"
				[dataKey]="'seqNo'"
				[tableKey]="preferenceKey"
				[defaultColumns]="tenantMappingUserGroupDetailColumns"
				[value]="tenantMappingUserGroupDetailData"
				[loading]="isLoading"
				[paginator]="false"
				[scrollHeight]="'500px'">

				<ng-template pTemplate="body" let-rowData let-columns="columns" let-expanded="expand">
					<td *ngFor="let col of columns">
						<div class="overflow-text">
							{{ rowData[col.field] | replaceNullWith:'-'}}
						</div>
					</td>
				</ng-template>
			</laas-data-table>
	</p-card>
</p-dialog>